import findIndex from 'lodash/findIndex'
import first from 'lodash/first'
import last from 'lodash/last'
import { useCallback, useContext } from 'react'

import { SearchContext } from '@Globals/Search/Context'

export const useGoTo = () => {
  const { previousSearches, results, setSelection } = useContext(SearchContext)

  // Brand
  const brandFirst = useCallback(() => {
    console.info('[search] results: attempting to select first brand')
    const brand = first(results?.brands)

    if (brand?.objectID) {
      setSelection({ objectID: brand.objectID, type: 'brand' })
      return true
    }

    return false
  }, [results?.brands, setSelection])
  const brandLast = useCallback(() => {
    console.info('[search] results: attempting to select last brand')
    const brand = last(results?.brands)

    if (brand?.objectID) {
      setSelection({ objectID: brand.objectID, type: 'brand' })
      return true
    }

    return false
  }, [results?.brands, setSelection])
  const brandNext = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select next brand')
    const index = findIndex(results?.brands, ['objectID', objectID])
    const brand = results?.brands?.[index + 1]

    if (brand?.objectID) {
      setSelection({ objectID: brand.objectID, type: 'brand' })
      return true
    }

    return false
  }, [results?.brands, setSelection])
  const brandPrevious = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select previous brand')
    const index = findIndex(results?.brands, ['objectID', objectID])
    const brand = results?.brands?.[index - 1]

    if (brand?.objectID) {
      setSelection({ objectID: brand.objectID, type: 'brand' })
      return true
    }

    return false
  }, [results?.brands, setSelection])

  // Category
  const categoryFirst = useCallback(() => {
    console.info('[search] results: attempting to select first category')
    const category = first(results?.categories)

    if (category?.objectID) {
      setSelection({ objectID: category.objectID, type: 'category' })
      return true
    }

    return false
  }, [results?.categories, setSelection])
  const categoryLast = useCallback(() => {
    console.info('[search] results: attempting to select last category')
    const category = last(results?.categories)

    if (category?.objectID) {
      setSelection({ objectID: category.objectID, type: 'category' })
      return true
    }

    return false
  }, [results?.categories, setSelection])
  const categoryNext = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select next category')
    const index = findIndex(results?.categories, ['objectID', objectID])
    const category = results?.categories?.[index + 1]

    if (category?.objectID) {
      setSelection({ objectID: category.objectID, type: 'category' })
      return true
    }

    return false
  }, [results?.categories, setSelection])
  const categoryPrevious = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select previous category')
    const index = findIndex(results?.categories, ['objectID', objectID])
    const category = results?.categories?.[index - 1]

    if (category?.objectID) {
      setSelection({ objectID: category.objectID, type: 'category' })
      return true
    }

    return false
  }, [results?.categories, setSelection])

  // Freetext
  const freetext = useCallback(() => {
    console.info('[search] results: selecting freetext')
    setSelection({ type: 'freetext' })
    return true
  }, [setSelection])

  // Input
  const input = useCallback(() => {
    console.info('[search] selecting input')
    setSelection({ type: 'input' })
    return true
  }, [setSelection])

  // PreviousSearch
  const previousSearchFirst = useCallback(() => {
    console.info('[search] results: attempting to select first previousSearch')
    const previousSearch = first(previousSearches)

    if (previousSearch?.id) {
      setSelection({ id: previousSearch.id, type: 'previoussearch' })
      return true
    }

    return false
  }, [previousSearches, setSelection])
  const previousSearchLast = useCallback(() => {
    console.info('[search] results: attempting to select last previousSearch')
    const previousSearch = last(previousSearches)

    if (previousSearch?.id) {
      setSelection({ id: previousSearch.id, type: 'previoussearch' })
      return true
    }

    return false
  }, [previousSearches, setSelection])
  const previousSearchNext = useCallback((id: string) => {
    console.info('[search] results: attempting to select next previousSearch')
    const index = findIndex(previousSearches, ['id', id])
    const previousSearch = previousSearches?.[index + 1]

    if (previousSearch?.id) {
      setSelection({ id: previousSearch.id, type: 'previoussearch' })
      return true
    }

    return false
  }, [previousSearches, setSelection])
  const previousSearchPrevious = useCallback((id: string) => {
    console.info('[search] results: attempting to select previous previousSearch')
    const index = findIndex(previousSearches, ['id', id])
    const previousSearch = previousSearches?.[index - 1]

    if (previousSearch?.id) {
      setSelection({ id: previousSearch.id, type: 'previoussearch' })
      return true
    }

    return false
  }, [previousSearches, setSelection])

  // Product
  const productFirst = useCallback(() => {
    console.info('[search] results: attempting to select first product')
    const product = first(results?.products)

    if (product?.objectID) {
      setSelection({ objectID: product.objectID, type: 'product' })
      return true
    }

    return false
  }, [results?.products, setSelection])
  const productNext = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select next product')
    const index = findIndex(results?.products, ['objectID', objectID])
    const product = results?.products?.[index + 1]

    if (product?.objectID) {
      setSelection({ objectID: product.objectID, type: 'product' })
      return true
    }

    return false
  }, [results?.products, setSelection])
  const productPrevious = useCallback((objectID: string) => {
    console.info('[search] results: attempting to select previous product')
    const index = findIndex(results?.products, ['objectID', objectID])
    const product = results?.products?.[index - 1]

    if (product?.objectID) {
      setSelection({ objectID: product.objectID, type: 'product' })
      return true
    }

    return false
  }, [results?.products, setSelection])

  return {
    brandFirst,
    brandLast,
    brandNext,
    brandPrevious,
    categoryFirst,
    categoryLast,
    categoryNext,
    categoryPrevious,
    freetext,
    input,
    previousSearchFirst,
    previousSearchLast,
    previousSearchNext,
    previousSearchPrevious,
    productFirst,
    productNext,
    productPrevious,
  }
}
